import { lazy } from 'react';

const Support = lazy(() => import('./SupportPage'));

const AgentSupportConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'agent/support',
      element: <Support />,
    },
  ],
};

export default AgentSupportConfig;
